module.exports = __webpack_public_path__ + "img/clogo.ca312e6b.png";